import { useTranslation } from "react-i18next";
import "./ProductInfoModalCard.scss";

export const ProductInfoModalCard = ({ infoData, isOpen, onClose }) => {
  const { t } = useTranslation("productModule");

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{t("product-details-modal-title")}</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-content">
          {infoData && (
            <div className="pop-up-contents">
              <div className="top-section">
                <img
                  src={
                    infoData.imageUrl
                      ? `${infoData.imageUrl}`
                      : "placeholder.png"
                  }
                  alt={infoData.name}
                  className={`${!infoData.imageUrl ? "placeholder" : "more-info-image-url"}`}
                />
                <div className="top-section-text-wrapper">
                  <p className="info-brand">{infoData.brand}</p>
                  <p className="info-name">{infoData.name}</p>
                  <div
                    className={`info-score-badge ${infoData.score >= 0.75 ? "best_green" : infoData.score >= 0.5 ? "very_good_green" : "good_green"}`}
                  >
                    {infoData.score >= 0.75 ? (
                      <p>{t("best-fit-tag")}</p>
                    ) : infoData.score >= 0.5 ? (
                      <p>{t("very-good-tag")}</p>
                    ) : (
                      <p>{t("good-tag")}</p>
                    )}
                  </div>
                </div>
              </div>
              {infoData.url && (
                <button
                  className="info-shop-button"
                  onClick={() => {
                    const newWindow = window.open(
                      infoData.url,
                      "_blank",
                      "noopener,noreferrer",
                    );
                    if (newWindow) newWindow.opener = null;
                  }}
                >
                  {t("to-the-shop")}
                </button>
              )}
              <p className="why-text">{t("why-product-fit")}</p>
              <div className="ingredient-info-wrapper">
                <p className="ingredient-title">{t("Ingredients")}</p>
                <div className="ingredient-percentage-card-wrapper">
                  <div className="ingredient-percentage-card">
                    <p className="ingredient-badge-green">
                      {t("Positive-Ingredient")}
                    </p>
                    <p className="ingredient-count">
                      {Math.round(infoData.score * infoData.totalIngredients)}
                    </p>
                    <p className="ingredient-percentage">
                      {Math.round(infoData.score * 100)}%
                    </p>
                    <p className="ingredient-percentage-info">
                      {t("helpful-ingredients-text")}
                    </p>
                  </div>
                  <div className="ingredient-percentage-card">
                    <p className="ingredient-badge-gray">
                      {t("Neutral-Ingredient")}
                    </p>
                    <p className="ingredient-count">
                      {Math.round(
                        (1 - infoData.score) * infoData.totalIngredients,
                      )}
                    </p>
                    <p className="ingredient-percentage">
                      {Math.round((1 - infoData.score) * 100)}%
                    </p>
                    <p className="ingredient-percentage-info">
                      {t("neutral-ingredients-text")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
